/* eslint-disable no-process-env */
import { createReducer } from 'typesafe-actions';

import { getRuntimeConfig } from '@portal/common/dist/runtime-config';

import { nextHydrate, reconcileState } from '../hydrate';
import type { HydrateAction } from '../hydrate';

import { setIsServer } from './actions';
import type { ConfigAction, ConfigState } from './types';

export const initialConfigState: ConfigState = getRuntimeConfig();

export const configurationReducer = createReducer<
  ConfigState,
  ConfigAction | HydrateAction
>(initialConfigState)
  .handleAction(nextHydrate, (state, { payload: { config } }) => ({
    ...state,
    ...reconcileState<ConfigState>(config, initialConfigState),
  }))
  .handleAction(setIsServer, (state, { payload: IS_SERVER }) => ({
    ...state,
    IS_SERVER,
  }));
